module.exports = __webpack_public_path__ + "static/media/darkrporter.371a949f.png";